import { Node_Type } from 'ricos-types';
import React, { Component, useContext, useEffect } from 'react';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { containsUrl, normalizeUrl } from 'wix-rich-content-common';
import PropTypes from 'prop-types';

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
const SRC_TYPE_HTML = "html";
const SRC_TYPE_URL = "url";
const INIT_WIDTH = 350;
const INIT_HEIGHT = 550;
const DEFAULTS_CONFIG = { alignment: "center" };
({
  srcType: SRC_TYPE_HTML,
  src: "",
  config: __spreadValues$3({}, DEFAULTS_CONFIG)
});
const DEFAULTS_VIEWER = {};

const HTML_TYPE = "wix-draft-plugin-html";

var htmlStyles = {"htmlComponent":"KI6kV","htmlComponent_placeholder":"_5-Trj"};

const ROOT = "HtmlComponent";
const IFRAME_COMPONENT = "iframeComponent";

const htmlFixer = (html, pageURL) => {
  const isGoogleAds = html == null ? void 0 : html.includes("adsbygoogle");
  const isIncludePageUrl = html == null ? void 0 : html.includes("data-page-url=");
  if (pageURL && isGoogleAds && !isIncludePageUrl) {
    const updatedAd = `<ins class="adsbygoogle"
	data-page-url="${pageURL}"`;
    return html == null ? void 0 : html.replace(new RegExp('<ins class="adsbygoogle"', "g"), updatedAd);
  }
  return html;
};

var styles = {"iframe":"m4lnH"};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Iframe = (_a) => {
  var _b = _a, {
    iframeRef,
    isViewer
  } = _b, otherProps = __objRest(_b, [
    "iframeRef",
    "isViewer"
  ]);
  return /* @__PURE__ */ React.createElement(
    "iframe",
    __spreadValues$2({
      ref: iframeRef,
      className: styles.iframe,
      title: "remote content",
      "data-hook": IFRAME_COMPONENT,
      style: { backgroundColor: "transparent" },
      allow: isViewer ? "fullscreen; autoplay" : "fullscreen",
      allowFullScreen: true
    }, otherProps)
  );
};

var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const isSSR = typeof window === "undefined";
const HtmlSrcPath = "/html/2b2e4b_d767b483cae16e027c4ea8ac7906fbf4.html";
class IframeHtml extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { shouldRender: false });
    __publicField(this, "id", Math.random().toString(36).substr(2, 9));
    __publicField(this, "updateIframeContent", (content) => {
      var _a;
      this.shouldIgnoreLoad = true;
      (_a = this.iframe) == null ? void 0 : _a.contentWindow.postMessage(
        { type: "htmlPlugin:updateContent", id: this.id, content },
        "*"
      );
    });
    __publicField(this, "handleIframeMessage", ({ data }) => {
      const { type, id, height } = data;
      if (type === "htmlPlugin:heightResize" && id === this.id) {
        this.props.onHeightChange(height);
      }
    });
    __publicField(this, "handleIframeLoad", () => {
      !this.shouldIgnoreLoad && this.updateIframeContent(this.props.html);
    });
  }
  componentDidMount() {
    this.setState({ shouldRender: true });
    !isSSR && window.addEventListener("message", this.handleIframeMessage);
  }
  componentWillUnmount() {
    !isSSR && window.removeEventListener("message", this.handleIframeMessage);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.html !== nextProps.html) {
      this.updateIframeContent(nextProps.html);
    }
  }
  render() {
    const { iframeSandboxDomain, isViewer } = this.props;
    const strippedUrl = iframeSandboxDomain.replace(/\/$/, "");
    return this.state.shouldRender ? /* @__PURE__ */ React.createElement(
      Iframe,
      {
        style: { backgroundColor: "transparent" },
        onLoad: this.handleIframeLoad,
        iframeRef: (iframe) => this.iframe = iframe,
        isViewer,
        src: strippedUrl + HtmlSrcPath
      }
    ) : null;
  }
}
IframeHtml.propTypes = {
  html: PropTypes.string.isRequired,
  onHeightChange: PropTypes.any,
  iframeSandboxDomain: PropTypes.string,
  isViewer: PropTypes.bool
};
var IframeHtml$1 = IframeHtml;

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const IframeUrl = (props) => /* @__PURE__ */ React.createElement(
  Iframe,
  __spreadProps(__spreadValues$1({}, props), {
    sandbox: "allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"
  })
);

const getPageURL = (siteDomain) => {
  if (!siteDomain) {
    return;
  }
  const regex = /http.+com/gm;
  const res = regex.exec(siteDomain);
  if (res) {
    return res[0];
  }
};
const HtmlViewer = ({ settings, componentData, iframeSandboxDomain, isViewer = false }) => {
  var _a;
  const { isMobile, experiments } = useContext(RicosContext);
  const [elementRef, setElementRef] = React.useState(null);
  const [iframeHeight, setIframeHeight] = React.useState();
  useEffect(() => {
    const { width, height } = settings;
    const { containerData } = componentData;
    if (!containerData.width) {
      if (width) {
        containerData.width = { custom: width };
      } else if (elementRef) {
        containerData.width = { custom: elementRef.getBoundingClientRect().width };
      } else {
        containerData.width = { custom: INIT_WIDTH };
      }
    }
    if (!containerData.height) {
      containerData.height = { custom: height || INIT_HEIGHT };
    }
  }, [elementRef]);
  const setHeight = (height) => {
    if (height > 0 && height !== iframeHeight) {
      setIframeHeight(height);
    }
  };
  const getIframeHeight = () => {
    var _a2;
    const { containerData } = componentData;
    const maxDiff = iframeHeight && Math.min(50, iframeHeight * 0.1);
    let normalizedHeight = iframeHeight;
    const customHeight = (_a2 = containerData.height) == null ? void 0 : _a2.custom;
    if (customHeight) {
      if (typeof customHeight === "string" && customHeight.endsWith("%")) {
        return normalizedHeight || settings.height || INIT_HEIGHT;
      }
      if (!isNaN(parseInt(customHeight))) {
        normalizedHeight = iframeHeight && customHeight < iframeHeight && customHeight + maxDiff > iframeHeight ? iframeHeight : customHeight;
      }
    }
    return normalizedHeight || settings.height || INIT_HEIGHT;
  };
  const style = {
    width: isMobile ? "auto" : ((_a = componentData.containerData.width) == null ? void 0 : _a.custom) || settings.width || INIT_WIDTH + "px",
    height: getIframeHeight() + "px",
    maxHeight: iframeHeight
  };
  let html;
  if (componentData.html) {
    const pageURL = getPageURL(settings.siteDomain);
    html = htmlFixer(componentData.html, pageURL);
  }
  return /* @__PURE__ */ React.createElement("div", { className: htmlStyles.htmlComponent, ref: setElementRef, style, "data-hook": ROOT }, html ? /* @__PURE__ */ React.createElement(
    IframeHtml$1,
    {
      iframeSandboxDomain: iframeSandboxDomain || "https://www.filesusr.com",
      key: SRC_TYPE_HTML,
      tabIndex: 0,
      html,
      onHeightChange: setHeight,
      isViewer
    }
  ) : componentData.url && containsUrl(componentData.url) ? /* @__PURE__ */ React.createElement(
    IframeUrl,
    {
      key: SRC_TYPE_URL,
      tabIndex: 0,
      src: normalizeUrl(componentData.url),
      isViewer
    }
  ) : /* @__PURE__ */ React.createElement("div", { className: htmlStyles.htmlComponent_placeholder }));
};

const Html = ({ node, nodeIndex, NodeViewContainer }) => {
  const { iframeSandboxDomain, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    HtmlViewer,
    {
      componentData: node.htmlData,
      settings: config[HTML_TYPE],
      iframeSandboxDomain,
      isViewer: true
    }
  ));
};

const nodeViewRenderers = {
  [Node_Type.HTML]: Html
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginHtml = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS_VIEWER), config),
    type: HTML_TYPE,
    nodeViewRenderers
  };
};

export { HTML_TYPE, pluginHtml };
//# sourceMappingURL=viewer.js.map
